import { ICSSInJSStyle } from '@fluentui/styles';

export default {
  root: (): ICSSInJSStyle => ({
    textAlign: 'right',
  }),
};
